import { mapAuditFields } from '../../../lib/auditColumnDefs';
import type { StorefrontUrlSubmissionRow } from '../models/types';

export function mapStorefrontUrlSubmissionRow(item: Record<string, unknown>): StorefrontUrlSubmissionRow {
  return {
    id: Number(item.id),
    merchantId: Number(item.merchantId ?? 0),
    merchantName: String(item.merchantName ?? '—'),
    url: String(item.url ?? ''),
    status: String(item.status ?? 'PENDING'),
    rejectionReason: item.rejectionReason != null ? String(item.rejectionReason) : null,
    ...mapAuditFields(item),
  };
}

export function getApiErrorMessage(err: unknown, fallback: string): string {
  if (err && typeof err === 'object' && 'response' in err) {
    const message = (err as { response?: { data?: { message?: string } } }).response?.data?.message;
    if (message) return message;
  }
  if (err instanceof Error && err.message) return err.message;
  return fallback;
}

/** Lenient — the backend accepts either a full URL or a bare hostname (with an optional "*."
 * wildcard prefix), so this only rejects obviously-empty or space-containing input. */
export function isPlausibleStorefrontUrl(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed || /\s/.test(trimmed)) return false;
  return true;
}

export function formatSubmittedDateLabel(createdAt?: string | null): string {
  if (!createdAt) return '—';
  return new Date(createdAt).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}
